import React, { Component } from 'react';
import { RouteComponentProps, withRouter } from 'utils/withRouter';
import { ReturnUrl } from 'utils/enums';
import { LoginStore } from './LoginStore';
import { inject } from 'mobx-react';

interface RedirectPageProps {
  loginStore?: LoginStore;
}
@inject('loginStore')
class RedirectPageComponent extends Component<RouteComponentProps & RedirectPageProps>
{
  public componentDidMount() {
    if (this.props.location.search.includes('return_url=')) {
      this.props.loginStore!.setCurrentUserFetching(true);

      const queryParams = new URLSearchParams(this.props.location.search);
      const rUrl = queryParams.get('return_url');
      const dDateNow = new Date().valueOf();

      // `get` is null when the search merely *contains* "return_url=" — `?next_return_url=…`
      // passes the check above. `setItem` would have stored the string "null", and the login
      // store would later have sent the browser to `/null`.
      if (rUrl !== null) {
        window.localStorage.setItem(ReturnUrl.RETURN_URL, rUrl);
        window.localStorage.setItem(ReturnUrl.TIME_EXPIRED, dDateNow.toString());
      }
    }

    window.location.href = `${process.env.REACT_APP_AUTH_URL}/api/dataporten/auth`;
  }

  public render() {
    return (<></>);
  }
}

/**
 * Wrapped in withRouter because react-router 7 stopped injecting route props. Under v5 this
 * was rendered as `<Route component={RedirectPage} />`, which handed it history, location and
 * match; `element={<RedirectPage />}` hands it nothing.
 */
export const RedirectPage = withRouter(RedirectPageComponent);
